import React from 'react'
import { graphql, Link } from 'gatsby'

import PostSection from '../components/PostSection'
import CategoriesNav from '../components/CategoriesNav'
import Layout from '../components/Layout'
import './PeopleIndex.css'
import Image from '../components/Image'

/**
 * Filter posts by date. Feature dates will be fitered
 * When used, make sure you run a cronejob each day to show schaduled content. See docs
 *
 * @param {posts} object
 */
export const byDate = posts => {
  const now = Date.now()
  return posts.filter(post => Date.parse(post.date) <= now)
}

// Export Template for use in CMS preview
export const PeopleIndexTemplate = ({
  title,
  people,
  posts = [],
  contentType
}) => {
  const formattedPeople = byDate(people)
  return (
    <main className="People">
      <section className="Nav--Container container">
        <CategoriesNav indexName="People" indexSlug={`/people/`} hire={false} />
      </section>

      <section className="section thin">
        <div className="People--Container container Mini">
          {formattedPeople.map((person, index) => (
            <div className="People--Person relative">
              <Link to={person.slug} className="absolute" />
              <div className="Card--Image relative">
                <Image
                  background
                  src={person.featuredImage}
                  alt={person.title}
                />
              </div>
              <h3>{person.title}</h3>
              <p>{person.role}</p>
            </div>
          ))}
        </div>
      </section>

      {!!posts.length && (
        <section className="section">
          <div className="container">
            <header>
              <h3 className="MiniPosts--title">Stories</h3>
            </header>
            <PostSection
              postLimit={6}
              showLoadMore={false}
              mainPost={false}
              posts={posts}
            />
          </div>
        </section>
      )}
    </main>
  )
}

// Export Default PeopleIndex for front-end
const PeopleIndex = ({ data: { page, people, posts } }) => (
  <Layout
    meta={page.frontmatter.meta || false}
    title={page.frontmatter.title || false}
  >
    <PeopleIndexTemplate
      {...page}
      {...page.fields}
      {...page.frontmatter}
      people={people.edges.map(post => ({
        ...post.node,
        ...post.node.frontmatter,
        ...post.node.fields
      }))}
      posts={posts.edges.map(post => ({
        ...post.node,
        ...post.node.frontmatter,
        ...post.node.fields
      }))}
    />
  </Layout>
)

export default PeopleIndex

export const pageQuery = graphql`
  ## Query for PeopleIndex data
  ## Use GraphiQL interface (http://localhost:8000/___graphql)
  ## $id is processed via gatsby-node.js
  ## query name must be unique to this file
  query PeopleIndex($id: String!) {
    page: mdx(id: { eq: $id }) {
      ...Meta
      fields {
        contentType
      }
      frontmatter {
        title
        excerpt
        template
        subtitle
        featuredImage
      }
    }

    people: allMdx(
      filter: { fields: { contentType: { eq: "people" } } }
      sort: { order: DESC, fields: [frontmatter___date] }
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            title
            role
            date
            featuredImage
          }
        }
      }
    }

    posts: allMdx(
      filter: { fields: { contentType: { eq: "stories" } } }
      sort: { order: DESC, fields: [frontmatter___date] }
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            title
            date
            categories {
              category
            }
            featuredImage
          }
        }
      }
    }
  }
`
